import type { Vehicle } from '../../types';
import { Card } from '../shared/Card';

interface VehicleBannerProps {
  vehicle: Vehicle;
  className?: string;
}

export const VehicleBanner = ({ vehicle, className }: VehicleBannerProps) => {
  return (
    <Card className={className}>
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
          <svg
            className="w-8 h-8 text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900">
            {vehicle.year} {vehicle.make} {vehicle.model}
          </h3>
          <div className="flex gap-4 mt-1 text-sm text-gray-600">
            <div>
              <span className="font-medium">VIN:</span> {vehicle.vin}
            </div>
            <div>
              <span className="font-medium">Plate:</span> {vehicle.plate}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
